module.exports = __webpack_public_path__ + "media/images/noimage-9233fbb227920d65f75f7f65d73c9516.jpg";